import { createGlobalStyle } from 'styled-components';
import { theme } from './theme';

const fontBase = process.env.PUBLIC_URL || '';

export const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Arcade Alternate';
    src:
      url('${fontBase}/ArcadeAlternate.woff2') format('woff2'),
      url('${fontBase}/ArcadeAlternate.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'BlockCraft';
    src: url('${fontBase}/BlockCraft.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  * {
    box-sizing: border-box;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: ${theme.fonts.display};
    font-weight: normal;
    letter-spacing: 0.02em;
  }

  body {
    margin: 0;
    background: ${theme.colors.bg};
    color: ${theme.colors.text};
    font-family: ${theme.fonts.body};
    font-size: ${theme.fontSizes.md};
    line-height: 1.5;
    -webkit-font-smoothing: none;
    -moz-osx-font-smoothing: unset;
  }

  button,
  input,
  textarea,
  select {
    font-family: inherit;
  }

  ::selection {
    background: ${theme.colors.accentSoft};
    color: ${theme.colors.text};
  }
`;
